<template>
  <transition name="notification-slide">
    <div class="customer-notification elevation-6">
      <div class="customer-notification__header">
        <v-icon small color="orange darken-2" class="mr-1">mdi-account-alert</v-icon>
        <span class="customer-notification__customer-name">{{ notification.customerName }}</span>
        <v-btn icon x-small class="customer-notification__close" @click="$emit('dismiss', notification)">
          <v-icon x-small>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="customer-notification__summary">
        {{ notification.summary }}
      </div>

      <div class="customer-notification__countdown">
        <div class="customer-notification__countdown-bar">
          <div
            class="customer-notification__countdown-fill"
            :style="{ width: countdownPercent + '%' }"
          />
        </div>
        <span class="customer-notification__countdown-text">{{ secondsLeft }}s</span>
      </div>

      <div class="customer-notification__actions">
        <v-btn
          small
          color="success"
          :loading="accepting"
          @click="$emit('accept', notification)"
        >
          <v-icon small left>mdi-check</v-icon>
          Accept
        </v-btn>
      </div>
    </div>
  </transition>
</template>

<script>
const COUNTDOWN_SECONDS = 60;

export default {
  name: 'CustomerReachingOutNotification',
  props: {
    notification: {
      type: Object,
      required: true
    },
    accepting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      secondsLeft: COUNTDOWN_SECONDS,
      intervalId: null
    };
  },
  computed: {
    countdownPercent() {
      return (this.secondsLeft / COUNTDOWN_SECONDS) * 100;
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.secondsLeft--;
      if (this.secondsLeft <= 0) {
        clearInterval(this.intervalId);
        this.$emit('dismiss', this.notification);
      }
    }, 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style scoped>
.customer-notification {
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  width: 300px;
  border-left: 4px solid #fb8c00;
  animation: slideIn 0.3s ease-out;
}

.customer-notification__header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.customer-notification__customer-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.customer-notification__close {
  margin-left: auto;
  flex-shrink: 0;
}

.customer-notification__summary {
  font-size: 12px;
  color: #555;
  line-height: 1.4;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.customer-notification__countdown {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.customer-notification__countdown-bar {
  flex: 1;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
}

.customer-notification__countdown-fill {
  height: 100%;
  background: #fb8c00;
  border-radius: 2px;
  transition: width 1s linear;
}

.customer-notification__countdown-text {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  min-width: 24px;
  text-align: right;
}

.customer-notification__actions {
  display: flex;
  justify-content: flex-end;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.notification-slide-enter-active {
  animation: slideIn 0.3s ease-out;
}

.notification-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.notification-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
